var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.outspinner)?_c('div',{staticClass:"spinner-wrapper logout-spinner"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"}),_c('p',[_vm._v("Please wait while we logout..")])])
}]

export { render, staticRenderFns }